(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("accounts", {
        templateUrl: "app/accounts/accounts.component.html",
        controller: ["authService", "frameworkService", "rolesResource", "groupHierarchyResource", "organizationsFilterResource", "messageService", "$localStorage", "$timeout", "$scope", "$state", "$translate", "DTOptionsBuilder", "USER_ROLES", "_", AccountListCtrl],
        controllerAs: "vm"
    });
    function AccountListCtrl(authService, frameworkService, rolesResource, groupHierarchyResource, organizationsFilterResource, messageService, $localStorage, $timeout, $scope, $state, $translate, DTOptionsBuilder, USER_ROLES, _) {
        var vm = this;
        vm.lang = $translate.proposedLanguage() || $translate.use();
        vm.isCreateAccountEnabled = !frameworkService.data.tenant.allowOnlyExternalLogins &&
            _.intersection(authService.authentication.roles, [USER_ROLES.organizationAdmin, USER_ROLES.groupAdmin, USER_ROLES.siteAdmin, USER_ROLES.superAdmin]).length > 0;
        vm.hasGroups = frameworkService.data.tenant.hasGroups;
        vm.organizationEnabled = frameworkService.data.tenantFeatures.organization;
        vm.mostRecentAccounts = $localStorage.mostRecentAccounts;
        vm.rowClickHandler = rowClickHandler;
        vm.dtInstance = {};
        vm.roles = [];
        vm.isSuperAdmin = authService.isSuperAdmin();
        vm.statuses = [{ "id": 1, "status": "Enabled" }, { "id": 0, "status": "Disabled" }, { "id": 2, "status": "Anonymized" }];
        rolesResource.query(function (data) {
            vm.roles = data;
        });
        if (vm.hasGroups) {
            groupHierarchyResource.query({ showAllGroups: true }, function (data) {
                vm.groups = data;
            });
        }
        /////////////////////////////////////////////////////////////////
        vm.getOrganizations = function (val) {
            if (angular.isUndefined(val) || val === null)
                val = "";
            return organizationsFilterResource.getCachedAll({ name: val }).$promise.then(function (result) {
                return result;
            }, function (error) {
                messageService.error(error);
            });
        };
        vm.onSelect = function (organization) {
            vm.filters.organization.value = organization.name;
            vm.reloadTable();
        };
        vm.organizationChanged = function () {
            vm.reloadTable();
        };
        if ($localStorage.accountListFilters) {
            vm.filters = $localStorage.accountListFilters;
        }
        else {
            vm.filters = {
                firstName: { enabled: true, value: "" },
                lastName: { enabled: true, value: "" },
                email: { enabled: true, value: "" },
                roles: { enabled: true, value: "-1" },
                organization: { enabled: false, value: "" },
                groups: { enabled: true, value: {} },
                status: { enabled: true, value: [] },
                regNo: { enabled: true, value: "" }
            };
        }
        var tableReloading = false;
        var reloadTableTimeout;
        vm.reloadTable = function () {
            if (tableReloading) {
                if (reloadTableTimeout)
                    $timeout.cancel(reloadTableTimeout);
                reloadTableTimeout = $timeout(function () {
                    vm.reloadTable();
                }, 200);
            }
            else {
                tableReloading = true;
                $timeout(function () {
                    $localStorage.accountListFilters = vm.filters;
                    vm.dtInstance.reloadData(function () {
                        tableReloading = false;
                    });
                });
            }
        };
        vm.refreshFilter = function (value) {
            $localStorage.accountListFilters = vm.filters;
            // reload only if filtered
            if (value && value.length > 0)
                vm.dtInstance.reloadData();
        };
        vm.closeFilter = function (filter) {
            vm.filters[filter].enabled = false;
            if (vm.filters[filter].hasOwnProperty("value")) {
                if (vm.filters[filter].value.hasOwnProperty("name"))
                    vm.refreshFilter(vm.filters[filter].value.name);
                else
                    vm.refreshFilter(vm.filters[filter].value);
            }
            else if (vm.filters[filter].hasOwnProperty("fromValue")) {
                vm.refreshFilter(vm.filters[filter].fromValue + vm.filters[filter].toValue);
            }
        };
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption("ajax", {
            url: "/api/accountSearch",
            error: function (error) {
                if (error.status === 401) {
                    $state.go("main.signIn");
                    return;
                }
                else if (error.status === 403) {
                    $state.go("main.accessDenied");
                    return;
                }
                messageService.error("common.genericError");
                $(".dataTables_processing").hide();
            },
            type: "POST",
            headers: {
                Authorization: "Bearer " + authService.getToken(),
                CurrentLocalizationId: $localStorage.currentLocalizationId
            },
            data: function (data) {
                data.columns[0].search.value = vm.filters.firstName.enabled ? vm.filters.firstName.value : "";
                data.columns[1].search.value = vm.filters.lastName.enabled ? vm.filters.lastName.value : "";
                data.columns[2].search.value = vm.filters.regNo.enabled ? vm.filters.regNo.value : "";
                data.columns[3].search.value = vm.filters.email.enabled ? vm.filters.email.value : "";
                data.columns[4].search.value = vm.filters.roles.enabled ? vm.filters.roles.value : "";
                data.columns[5].search.value = vm.filters.organization.enabled ? vm.filters.organization.value : "";
                data.columns[6].search.value = "";
                if (vm.filters.groups.enabled && vm.filters.groups.value && vm.filters.groups.value.id)
                    data.columns[6].search.value = vm.filters.groups.value.id;
                data.columns[7].search.value = vm.filters.status.enabled ? vm.filters.status.value.join("|") : "";
                switch (data.order[0].column) {
                    case 3:
                        data.order[0].column = 2;
                        break;
                    case 4:
                        data.order[0].column = 3;
                        break;
                }
            }
        })
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withDataProp("data")
            .withOption("processing", true)
            .withOption("serverSide", true)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("stateSave", true)
            .withOption("stateDuration", -1)
            .withOption("stateSaveParams", function (_settings, data) {
            //EXAMPLE datatables do not save state of column visibility
            data.columns.forEach(function (column) {
                delete column.visible;
            });
        })
            .withOption("rowCallback", rowCallback)
            .withOption("fnDrawCallback", function () {
            vm.dtInstance.DataTable.column(4).visible = vm.organizationEnabled;
            vm.dtInstance.DataTable.column(5).visible = vm.hasGroups;
        })
            .withPaginationType("full_numbers")
            .withBootstrap();
        vm.dtColumns = [
            { "data": null, "defaultContent": "", "class": "control", "orderable": false, "targets": 0 },
            { "data": "name", "title": $translate.instant("common.lists.learner") },
            { "data": "name", "visible": false },
            { "data": "personSeq", "title": $translate.instant("common.regNo"), "class": "text-nowrap" },
            { "data": "email", "title": $translate.instant("common.lists.email") },
            { "data": "organization", "title": $translate.instant("common.lists.organization"), "visible": vm.organizationEnabled },
            { "data": "groups", "orderable": false, "title": $translate.instant("common.lists.groups"), "visible": vm.hasGroups },
            {
                "data": "status",
                "title": $translate.instant("common.lists.status"),
                "render": function (data) {
                    return $translate.instant("common.userStatus." + data);
                }
            }
        ];
        $scope.$on("reloadAccountList", function () {
            vm.reloadTable();
        });
        function rowClickHandler(row) {
            $state.go("main.people.accountsEdit", { personSeq: row.personSeq });
        }
        function rowCallback(row, data) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $("td:not(.control)", row).unbind("click");
            $("td:not(.control)", row).bind("click", function () {
                $scope.$apply(function () {
                    vm.rowClickHandler(data);
                });
            });
            return row;
        }
    }
}());
